import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/Input';
import Modal from 'components/Modal';
import reactDatepickerWrapper from 'assets/styles/datepickerWrapper.style';
import TimePicker from 'components/TimePicker';
import DatePicker from 'components/DatePicker';
import Dropdown from 'components/Dropdown';
import SelectUsersDropdown from 'containers/SelectUsersDropdown';
import SelectTeamsDropdown from 'containers/SelectTeamsDropdown';
import {
    ModalCustomBodyStyle,
    TwoColumnGrid,
    StyledButton,
    InputSection,
    Title,
    StyledMemoInfo,
    StyledMemoWarning,
    Message,
} from './AddAdminMemoModal.style';

export const SEND_TO_OPTIONS = {
    send_to_all_users: 'all_users',
    send_to_selected_users: 'users',
    send_to_selected_teams: 'teams',
};

export const TYPE_OPTIONS = {
    type_informational: 'type_informational',
    type_critical: 'type_critical',
};

export const sendToOptions = [
    { id: SEND_TO_OPTIONS.send_to_all_users, label: 'All Users' },
    { id: SEND_TO_OPTIONS.send_to_selected_users, label: 'Select Users' },
    { id: SEND_TO_OPTIONS.send_to_selected_teams, label: 'Select teams' },
];

export const typeOptions = [
    {
        id: 'informational_memo',
        label: 'Informational Memo',
        svg: <StyledMemoInfo />,
    },
    { id: 'critical_memo', label: 'Critical Memo', svg: <StyledMemoWarning /> },
];

const AddAdminMemoModal = ({
    closeModal,
    sendTo,
    setSendTo,
    type,
    setType,
    hour,
    setHour,
    date,
    setDate,
    message,
    setMessage,
    setUsers,
    setTeams,
    createAdminMemo,
}) => (
  <Modal
        closeModal={closeModal}
        headerText="Create new Admin Memo"
        isCloseIcon
        closeByIconClick={closeModal}
        modalFooter={() => (
          <>
            <StyledButton primary onClick={closeModal}>
              Cancel
            </StyledButton>
            <StyledButton
                    primaryDark
                    onClick={createAdminMemo}
                    disabled={!message || message.length < 3}
                >
              Send
            </StyledButton>
          </>
        )}
    >
    <ModalCustomBodyStyle
            overflowY={
                sendTo.id === SEND_TO_OPTIONS.send_to_selected_users ||
                sendTo.id === SEND_TO_OPTIONS.send_to_selected_teams
            }
        >
      <InputSection shadow>
        <Title>Send to</Title>
        <Dropdown
                    fullWidth
                    withoutDivider
                    label={sendTo ? sendTo.label : sendToOptions[0].label}
                    options={sendToOptions}
                    onSelect={setSendTo}
                />
      </InputSection>

      {sendTo && sendTo.id === SEND_TO_OPTIONS.send_to_selected_users && (
        <InputSection shadow noPaddingTop>
          <Title noCentered>Choose Users</Title>
          <div>
            <SelectUsersDropdown onUpdate={setUsers} />
          </div>
        </InputSection>
            )}

      {sendTo && sendTo.id === SEND_TO_OPTIONS.send_to_selected_teams && (
        <InputSection shadow noPaddingTop>
          <Title noCentered>Choose teams</Title>
          <div>
            <SelectTeamsDropdown onUpdate={setTeams} />
          </div>
        </InputSection>
            )}

      <InputSection borderTop>
        <Title>Type</Title>
        <Dropdown
                    fullWidth
                    withoutDivider
                    label={type ? type.label : typeOptions[0].label}
                    labelSvg={type ? type.svg : typeOptions[0].svg}
                    options={typeOptions}
                    onSelect={setType}
                />
      </InputSection>

      <InputSection noPaddingTop>
        <Title>Date</Title>
        <TwoColumnGrid>
          <Input variant="group" noMargin>
            <TimePicker time={hour} setTime={setHour} />
          </Input>
          <Input
                        noMargin
                        variant="group"
                        customStyles={reactDatepickerWrapper}
                    >
            <DatePicker date={date} setNewDate={setDate} />
          </Input>
        </TwoColumnGrid>
      </InputSection>

      <InputSection noPaddingTop>
        <Title noCentered columnFlex>
          Message &nbsp;
          <small style={{ fontSize: '9px' }}>(required)</small>
        </Title>
        <Message
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                />
      </InputSection>
    </ModalCustomBodyStyle>
  </Modal>
);

AddAdminMemoModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    sendTo: PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
    }).isRequired,
    setSendTo: PropTypes.func.isRequired,
    type: PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        svg: PropTypes.node,
    }).isRequired,
    setType: PropTypes.func.isRequired,
    hour: PropTypes.string.isRequired,
    setHour: PropTypes.func.isRequired,
    date: PropTypes.instanceOf(Date).isRequired,
    setDate: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    setMessage: PropTypes.func.isRequired,
    setUsers: PropTypes.func.isRequired,
    setTeams: PropTypes.func.isRequired,
    createAdminMemo: PropTypes.func.isRequired,
};

AddAdminMemoModal.defaultProps = {};

export default AddAdminMemoModal;
